<template>
    <div class="container-fluid mt--6 tbl-flt-sch">
      <div class="row xsOnly">
        <div class="col-xl-12">
            <div class="card scrollbar vh-75" id="scroll">
                <div class="table-responsive">
                    <!-- <h4 class="d-inline-block py-4">
                  <div class="">
                    Total Quantity  : <span class="badge">{{totalCount ? totalCount : 0}}</span> 
                    Total Price : <span class="badge">{{totalPrice | currency}}</span>
                  </div>
                </h4> -->
                    <div class="input-group col-md-2 tab-sch tbl-sch rounded">
                        <input v-on:keyup.enter="searchInventory" type="text" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control rounded" placeholder="Search" />
                        <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
                        <span @click="searchInventory()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
                    </div>
                    <div class="col-md-3 tbl-filter mt-2">
                    <multiselect 
                                v-model="filterType" 
                                placeholder="Filter By Type"
                                :options="filterTypeList" 
                                :limit="3"  ></multiselect>
                    <button @click="searchInventory()" type="button" class="flt-btn btn btn-success"><i class="fas fa-filter"></i></button>
                  </div>
                    <!-- Table Search -->
                    <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                        <thead class="thead-light psticky">
                        <tr>
                            <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                                @click="sort('cusip')" >CUSIP</th>
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'qtyInPositions'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'qtyInPositions'  ? 'sort-desc' : '']"  
                                @click="sort('qtyInPositions')" >QTY IN POSITIONS FILE</th> 
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                                @click="sort('quantity')" >QTY</th> 
                            <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'boughtDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'boughtDate'  ? 'sort-desc' : '']"  
                                @click="sort('boughtDate')" >BOUGHT DATE</th>
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                                @click="sort('cost')" >COST</th> 
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'assignedTo'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'assignedTo'  ? 'sort-desc' : '']"  
                                @click="sort('assignedTo')" > Assigned To</th>  
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'broughtIn'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'broughtIn'  ? 'sort-desc' : '']"  
                                @click="sort('broughtIn')" > Bought Account </th>
                                
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'notes'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'notes'  ? 'sort-desc' : '']"  
                                @click="sort('notes')" > notes</th>
                                <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'type'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'type'  ? 'sort-desc' : '']"  
                                @click="sort('type')" > type</th> 
                                <!-- <th 
                                scope="col" 
                                class="sort"
                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'type'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'type'  ? 'sort-desc' : '']"  
                                @click="sort('type')" > bought in </th>    -->
                              
                                <th 
                                scope="col" 
                                class="">Action</th>  
                        </tr>
                        </thead>
                        <tbody class="list no-cursor">
                        <tr v-if="totalRows == 0 && !loading">
                            <td><p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="(inventory) in inventoryList" :key="inventory.id" >
                            <td class="">
                                <span>{{inventory.cusipVal}}</span>
                            </td>
                            <td class="">
                                <span>{{inventory.qtyInPositions}}</span>
                            </td>
                            <td class="">
                                <input v-model="inventory.quantity" type="number"  class="form-control h-25">
                            </td>
                            <td class="col-md-1">
                                <date-picker  :format="'DD-MM-YYYY'" v-model="inventory.boughtDate" valueType="MM/DD/YYYY"></date-picker>
                                <!-- <div>
                                <datetime 
                                class="h-25"
                                    :disabled-dates="disabledDates" 
                                    v-model="inventory.boughtDate" 
                                    format="MM/DD/YYYY" 
                                    :name="'dateinput'+index"
                                    width="100%"  
                                    placeholder="MM/DD/YYYY"></datetime>
                                </div> -->
                                
                            </td>
                            <td class="">
                                <input v-model="inventory.cost" type="number"  class="form-control h-25">
                            </td>
                            <td class="col-md-2">
                                <multiselect 
                                    style="height: 33px;"
                                    v-model="inventory.assignedToUser" 
                                    placeholder="Select user" 
                                    label="firstName" 
                                    track-by="id"
                                    :options="userList"  
                                    :limit="3"  ></multiselect>
                            </td>
                            <td class="col-md-2 h-25">
                                <multiselect 
                                    v-model="inventory.selectedAccount" 
                                    placeholder="Select account" 
                                    label="fullName" 
                                    track-by="accountMappingId"
                                    :options="accountList"  
                                    :limit="3"  ></multiselect>
                            
                                <!-- <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select" v-model="inventory.accountMappingId">
                                    <option v-for="(item , i) in accountList" :key="'A'+ i" :value="item.accountMappingId"> {{ item.customerName}} - {{ item.account}}</option>
                                </select> -->
                                <!-- {{inventory.broughtIn}} -->
                            </td>
                            <td class="">
                                <textarea class="form-control" style="height: auto;" v-model="inventory.notes"  rows="2" cols="30" ></textarea>
                            </td>
                            <td>
                                <span class="cusor-pointer" >{{inventory.type}}</span>
                            </td>
                            <!-- <td class="">
                                <span>{{inventory.broughtIn}}</span>
                            </td> -->
                            
                            <td class="">
                                <div class="d-inline-flex"> 
                                    <button v-if="inventory.type == 'MISSING'" :disabled="loading" @click="addInventory(inventory)"  type="button" class="btn btn-success btn-sm my-2" ><i  class="fas fa-plus"></i> ADD</button>
                                    <button v-if="inventory.type == 'MISMATCH'" :disabled="loading" @click="updateInventory(inventory)"  type="button" class="btn btn-success btn-sm my-2" ><i  class="fas fa-edit"></i> UPDATE</button>
                                   
                                </div>    
                            </td>
                        </tr>
                        </tbody>
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                    </table>
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getInventoryList(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                  
                </div>
            </div>
        </div>
      </div>
    </div>                

</template>
<script>

import config from "@/config";
import authService from "@/authService";
// import Datepicker from 'vuejs-datepicker';
// import datetime from 'vuejs-datetimepicker';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: "imsinventoryListError",
  components :{
    DatePicker,
    // datetime
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "account",
        sortOrder: "ASC",
        inventoryList : [],
        disabledDates: {
            from: new Date()
        },
        userList : [],
        accountList : [],
        filterTypeList : ['MISSING','MISMATCH'],
        filterType : ""


    };
  },
  methods: { 
      getAllAccountList() {
          this.loading = true;

          const auth = {
              headers: { 'org-token': authService.getOrgToken() }
          };
          this.$http
              .get(
                  config.baseUrlBidSide +
                  "/inventory/account-map-list",
                  auth
              )
              .then(result => {
                  
                result.data =   result.data.map((data) =>  {data.fullName =  data.customerName +" - "+ data.account;return data})      
                this.accountList = result.data.filter((acc) => { return acc.account == 'SMU000002' || acc.account == 'SMU000001' });
                this.getUserList()
              })
      },
    getUserList(){             
        const auth = {
            headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=",
                auth
            )
            .then(result => {
            result.data.content.forEach(trader =>{
                trader.firstName =  trader.firstName+" "+trader.lastName;
            });
            this.userList = result.data.content;
            this.getInventoryList()

            // this.filterUser = this.userList.find((user) => user.id == this.selectedInventory.assignedTo)
            
            })
            .catch(e => {
            console.log(e);
            });
    },
    addInventory(addtoinv){
        // console.log(addtoinv)
        let isValid = this.checkForm(addtoinv);
        if (isValid) {
            this.loading = true;
            var addData = {};
            addData.accountMappingId = addtoinv.selectedAccount.accountMappingId;
            addData.cusipId = addtoinv.cusipId;
            addData.quantity = addtoinv.quantity;
            addData.boughtDate = addtoinv.boughtDate
            addData.cost = addtoinv.cost;
            addData.notes = addtoinv.notes;
            addData.assignedTo = addtoinv.assignedToUser ? addtoinv.assignedToUser.id : "";
            // console.log(addData)
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .post(config.baseUrlBidSide + "/inventory", addData, auth)
            .then(() => {
                this.$alert("Holding Added","","success")
                this.loading = false;   
                this.getInventoryList();       
            })
            .catch(() => {
                this.loading = false;              
            });
        }
     },
    processInventoryUpdate(addtoinv){
        this.loading = true;
        var addData = {};
        addData.inventoryId = addtoinv.id
        addData.accountMappingId = addtoinv.selectedAccount.accountMappingId;
        addData.cusipId = addtoinv.cusipId;
        addData.quantity = addtoinv.quantity;
        addData.boughtDate = addtoinv.boughtDate
        addData.cost = addtoinv.cost;
        addData.notes = addtoinv.notes;
        addData.assignedTo = addtoinv.assignedToUser ? addtoinv.assignedToUser.id : "";
        // console.log(addData)
        const auth = {
            headers: { 'org-token' : authService.getOrgToken()  }
        };
        this.$http
        .put(config.baseUrlAutoBidder + "/inventory/mismatch-edit", addData, auth)
        .then(() => {
            this.$alert("Holding Updated","","success")
            this.loading = false;   
            this.getInventoryList();       
        })
        .catch(() => {
            this.loading = false;              
        });

    },
    updateInventory(addtoinv){
        // console.log(addtoinv)
        let isValid = this.checkForm(addtoinv);
       
        if (isValid) {
            if(addtoinv.filledQuantity > addtoinv.quantity ){
                this.$alert("Quantity cannot be less than filled quantity","","error");
                return true;
            }
            if(addtoinv.inventoryCount > 1){
                this.$confirm(`This CUSIP has multiple inventory holdings (total: ${addtoinv.inventoryCount}). Continue?`,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                    this.processInventoryUpdate(addtoinv)
                })
            }else{
                this.processInventoryUpdate(addtoinv)
            }
        }
     }, 

     checkForm(inv){
        
            if (!inv.quantity) {
            this.$alert("Quantity is required.","","error");
            return false;
        }
        // console.log(inv.boughtDate)
        if (!inv.boughtDate) {
            this.$alert("Bought date is required.","","error");
            return false;
        }
        if (!inv.cost) {
            this.$alert("Cost is required.","","error");
            return false;
        }
        if (!inv.selectedAccount) {
            this.$alert("BOT IN Account is required.","","error");
            return false;
        }
        return true
    },
    changeFilter(){
        setTimeout(()=>{
            this.searchInventory()
        },100)
    },
    searchInventory(){
        this.getInventoryList(); 
    },
    clearSearch(){
        this.searchValue = "";
        this.getInventoryList(); 
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getInventoryList();
    },

    getInventoryList(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/inventory/list-missing-invholdings?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&accountNumber="+
            "&type=" +
            (this.filterType ? this.filterType : "" ),
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.map((inv) => {
            inv.assignedToUser = this.userList.find((user) => user.id == inv.assignedTo)
            inv.selectedAccount =  this.accountList.find((account) => account.account == inv.broughtIn);

          })

          this.inventoryList = result.data.content;


          this.loading = false;
        }).catch(() => this.loading = false);
    }

   
  },
  mounted() {
    this.getAllAccountList();
   // this.getUserList();
    // this.getInventoryList()

  }
};
</script>
<style scoped>

.imstbl input{
    height: 40px !important;
}
</style>
